import Axios from 'axios'
import qs from 'qs'
// 唐山
let tenantUUID = '';
let tenantUUIDTwo = '7b817b8ded9e41d8bd7ed16f6847cd31';
//延津
// let tenantUUID = '203dcfcc1b9d4fe28446f447f23aa8a3';//延津租户
// let tenantUUIDTwo = '203dcfcc1b9d4fe28446f447f23aa8a3';//延津
Axios.defaults.withCredentials = true;
export const base = "http://111.63.4.38:8000"; //唐山正式
// export const base = "http://39.98.66.183:8000"; //延津

// export const GROUP_TITLE = '代表之家';
export const GROUP_TITLE = '联络站';
export const REP_TYPE = '1'; //0 =县市区 1=市
let http = Axios.create({
  baseURL: base,
});
let HTTP = Axios.create({
  baseURL: base,
  transformRequest: [function (data) {
    data = qs.stringify(data);
    return data;
  }]
});
// 获取所有代表之家信息
export const findAllStation = params => {
  return HTTP.post('/liaison/findAllStation?executor=', params).then(response => response.data)
};
// 获取部分代表之家信息
export const findLiaisonStation = params => {
  return HTTP.get('/liaison/findLiaisonStationBySearch?' + 'region=' + params.region + '&parentRegion=' + params.parentRegion + '&name=' + params.name + '&uuid=' + params.uuid + '&parentStationUuid=' + params.parentStationUuid + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize + '&tenantUUID=' + tenantUUID, params).then(response => response.data)
};
// 获取代表之家区域
export const findLiaisonRegion = params => {
  console.log(params)
  return HTTP.get('/region/findLiaisonRegion?uuid=' + params.uuid + '&tenantUUID=' + tenantUUID + '&name=' + params.name + '&parentRegionUuid=' + params.parentRegionUuid + '&pageIndex=0' + '&pageSize=100000' + "&areaCode=" + params.areaCode, params).then(response => response.data)
};
// 获取公示公告
export const findNoticeAnnouncement = params => {
  return HTTP.post('/notice/findNoticeAnnouncement', params).then(response => response.data)
};
// 获取工作动态
export const findWorkDynamics = params => {
  return HTTP.post('/work/findWorkDynamics', params).then(response => response.data)
};
// 获取工作动态
export const findRepPerformance = params => {
  return HTTP.post('/performance/findRepPerformance', params).then(response => response.data)
};
export const getRepInfo = params => {
  return http.get('/rep/findRI?delegationCode=' + params.delegationCode + '&uuid=' + params.uuid + '&representCategory=' + params.representCategory + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize + '&searchKey=' + params.searchKey + '&isJoined=&sexCode=&nationCode=&politicalStatusCode=&educationCode=&pageSize=&assessStatus=&reElection=&representType=&liaisonStationUuid=' + params.liaisonStationUuid + '&startAge=&endAge=' + '&tenantUUID=' + tenantUUID).then(response => response.data)
};

// 获取图片新闻
export const getNews = params => {
  return HTTP.get('/api/articles?' + 'pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize + '&navCode=' + params.navName + '&tenantUUID=' + tenantUUID).then(response => response.data)
};
// 获取图片新闻
export const getPics = url => {
  return base + '/uploadfile/photoBark/' + url;
};
// 查询各委室
export const findDeptinfo = params => {
  return HTTP.post('/deptinfo/findDeptinfo?tenantUUID=' + tenantUUID + '&deptType=' + params.deptType + '&uuid=' + params.uuid + '&parentDeptCode=' + params.parentDeptCode + '&deptCode=' + params.deptCode, params).then(response => response.data)
};
// // 提交建议
// export const addSuggest = params => {
//     return http.post('/supervision/saveSI?vcode=' + params.vcode, params).then(response => response.data)
// };
// 提交建议
export const addSuggest = params => {
  return http.post('/leavingMessage/addLeavingMessage', params).then(response => response.data)
};
// 代表之家新闻发布查询
export const findNewsRelease = params => {
  return http.get('/newsRelease/findNewsRelease?pageIndex=' + params.pageIndex +
    '&pageSize=' + params.pageSize +
    '&liaisonStationName=' + params.liaisonStationName +
    '&type=' + params.type +
    '&liaisonStationUuid=' + params.liaisonStationUuid +
    '&title=' + params.title +
    '&uuid=' + params.uuid +
    '&tenantUUID=' + tenantUUID, params).then(response => response.data)
};
export const addLiaisonStationSuggestion = params => {
  return http.post('/liaisonSuggestion/addLiaisonStationSuggestion', params).then(response => response.data)
};
// 获取人大基本信息表
export const getQRCodeURL = params => {
  return http.get('/qrCode/getQRCodeURL?' + 'id=' + params.id + '&scene=&path=pages/peopleDetails/peopleDetails?id=' + params.id + '&tenantUUID=' + tenantUUIDTwo).then(response => response)
};
export const supervisionMessage = params => {
  return http.get('/supervision/supervisionMessage?phone=' + params.phone + '&code=11&tenantUUID=' + tenantUUIDTwo).then(response => response.data)
};

// 敏感词检测
export const sensitiveWordDetection = params => {
  return http.post('/supervision/sensitiveWordDetection', params).then(response => response.data)
};
/// 代表之家群众答复查询
export const getMessage = params => {
  return http.get('/leavingMessage/getMessage?phone=' + params.phone + '&tenantUUID=' + tenantUUIDTwo, params).then(response => response.data)
};
/// 代表之家群众答复查询
export const findLeavingMessage = params => {
  return http.get('/leavingMessage/findByPhone?phone=' + params.phone +
    '&code=' + params.code, params).then(response => response.data)
};



// WEBPACK FOOTER //
// ./src/api/api.js